"use client";

import LogoImage from "@/components/common/LogoImage";
import { CLIENT_LOGOS } from "@/constants/clients";
import { cn } from "@/utils/cn";

interface TrustedBySectionProps {
  className?: string;
}

function TrustedBySection({ className }: TrustedBySectionProps) {
  return (
    <section
      className={cn("flex flex-col items-center justify-center gap-x-4 gap-y-20 px-side py-20 tablet:gap-y-36", className)}
    >
      {/* 클라이언트 로고들 */}
      <div>
        <div className="mb-10 break-keep text-center text-18 font-semibold tablet:text-22 desktop:text-26">
          초기 IT 스타트업부터
          <br className="tablet:hidden" />
          <span className="hidden tablet:inline"> </span>
          Series B 이상 규모 기업과 대기업까지,
          <br />
          서치라이트AI와 함께 핵심 인재를 만나고 있습니다.
        </div>
        <div className="grid w-full max-w-[900px] grid-cols-2 justify-items-center gap-x-2 gap-y-4 tablet:flex tablet:flex-wrap tablet:justify-center tablet:gap-x-10 tablet:gap-y-6">
          {CLIENT_LOGOS.map((key) => (
            <LogoImage key={`trusted-by-${key}`} client={key} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default TrustedBySection;
